<template>
    <div>
        <a @click.prevent="onClick"
           v-if="height > 50"
           id="back-to-top" href="#" class="btn btn-dark back-to-top" role="button">
          BACK TO TOP
        </a>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                height: 0,
            }
        },
        methods: {
            handleScroll() {
                this.height = window.pageYOffset;
            },

            onClick() {

                $("html, body").animate({scrollTop: "0"});
            },
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>
